import { NationBuilderOrganizationType, NationBuilderPoliticalGroup } from '__generated__/types';
import BoxSelectField from 'projects/components/BriefFields/BoxSelectField';
import OtherField from 'projects/components/BriefFields/OtherField';
import ProfileApprovalField from 'projects/components/BriefFields/ProfileApprovalField';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';
import { nationBuilderOrganizationType, nationBuilderPoliticalGroup } from './enums';

interface Fields {
    organizationType: NationBuilderOrganizationType;
    politicalGroup: NationBuilderPoliticalGroup;
    profileApproval: boolean;
    other: string;
}

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
    };
}

export default function AboutYouPage<T extends Fields>(props: Props<T>) {
    const { form, brief } = props;

    useEffect(() => {
        trackViewedBriefEvent({ id: brief.id, page: 'AboutYou' });
    }, []);

    return (
        <ContentSetting>
            <BoxSelectField
                required
                form={form}
                name="organizationType"
                title={__('What best describes your organization type?')}
                options={nationBuilderOrganizationType}
            />
            <BoxSelectField
                required
                form={form}
                name="politicalGroup"
                title={__('Which group does your organization identify as?')}
                options={nationBuilderPoliticalGroup}
            />
            <ProfileApprovalField form={form} />
            <OtherField form={form} />
        </ContentSetting>
    );
}
